<template lang="pug">
  #ItemsListIndex.container-width
    //- h5.text-center.pt-2 我的工作管理
    b-card.rounded-0(
      bg-variant="light",
      v-for="(router,index) in routers",
      :key="index"
      v-if='router.isShow !== false'
    )
      router-link(
        :to="{name: router.routerPushName ? router.routerPushName : 'sm-items-list-index'}"
      )
        .row.no-gutters
          .col-2.pr-1.text-center
            //- Use Font Awesome Icon
            i.fa-lg(
              :class="router.iconClassName",
              style="font-size: 1.5rem;"
            )
          .col-10.pl-1
            span {{ router.name }}
</template>

<script>
import { SM_MSG_MANAGER_INDEX } from '@/router/sm/msg-manager';
import { SM_RESERVATION_INDEX } from '@/router/sm/reservation';
import { SM_CONTACTS_INDEX } from '@/router/sm/contacts';
import { SM_LABEL_INDEX } from '@/router/sm/label';
import { SM_STORES_MANAGER_INDEX } from '@/router/sm/stores-manager';
import { SM_PROFILE_INDEX } from '@/router/sm/profile';
import { SM_QR_CODE_INDEX } from '@/router/sm/qr-code';
import { SM_INVITATION_INDEX } from '@/router/sm/invitation';
import { SM_MEMBER_SEARCH_INDEX } from '@/router/sm/member-search';
import { SM_EVENT_ACTIVITY_INDEX } from '@/router/sm/event-activity';

export default {
  name: 'ItemsListIndex',
  data() {
    return {
      routers: [
        {
          name: '訊息管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SM_MSG_MANAGER_INDEX
        },
        {
          name: '我的預約',
          iconClassName: 'far fa-calendar-check',
          routerPushName: SM_RESERVATION_INDEX
        },
        {
          name: '顧客通訊錄',
          iconClassName: 'fas fa-users',
          routerPushName: SM_CONTACTS_INDEX
        },
        {
          name: '顧客標籤',
          iconClassName: 'fas fa-tag',
          routerPushName: SM_LABEL_INDEX
        },
        {
          name: 'QRcode',
          iconClassName: 'fas fa-qrcode',
          routerPushName: SM_QR_CODE_INDEX,
          isShow: true
        },
        {
          name: '修改個人資料',
          iconClassName: 'fas fa-edit',
          routerPushName: SM_PROFILE_INDEX
        },
        {
          name: '店鋪管理',
          iconClassName: 'fas fa-store',
          routerPushName: SM_STORES_MANAGER_INDEX
        },
        {
          name: '顧客查詢',
          iconClassName: 'fas fa-user',
          routerPushName: SM_MEMBER_SEARCH_INDEX
        },
        // {
        //   name: '邀請函',
        //   iconClassName: 'far fa-envelope',
        //   routerPushName: SM_INVITATION_INDEX,
        //   isShow: true
        // }
        {
          name: '活動預約',
          iconClassName: 'far fa-calendar-check',
          routerPushName: SM_EVENT_ACTIVITY_INDEX,
          isShow: process.env.VUE_APP_CAN_USE_EVENT_ACTIVITY === 'true'
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  }
};
</script>

<style>

</style>
